import React from "react";
import useAuthority from "../hooks/useAuthority";
import { AUTHORITY_TYPE, MODULES } from "../const";

const NavItem = ({ item, selectedCategory, handleItemClick }) => {
  const { view } = useAuthority({
    type: AUTHORITY_TYPE.MODULE,
    module: MODULES[item],
    editMode: false,
    authenticated: true,
  });
  return (
    <li
      key={item}
      className={`the-nav-menu-item ${item === selectedCategory ? "active" : ""}`}
      style={view ? {} : { display: "none" }}
    >
      <a onClick={() => handleItemClick(item)}>{item}</a>
    </li>
  );
};

export default NavItem;
